import { render, staticRenderFns } from "./Segment.vue?vue&type=template&id=73f163c3"
import script from "./Segment.vue?vue&type=script&lang=js"
export * from "./Segment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73f163c3')) {
      api.createRecord('73f163c3', component.options)
    } else {
      api.reload('73f163c3', component.options)
    }
    module.hot.accept("./Segment.vue?vue&type=template&id=73f163c3", function () {
      api.rerender('73f163c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Segment/Segment.vue"
export default component.exports